<template lang="pug">
video-base.video-control(preload='auto', controls, controlsList='nodownload')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import VideoBase from '@/components/atoms/VideoBase.vue'

/**
 * 操作パネル付きで動画表示
 */
@Component({
  components: {
    VideoBase,
  },
})
export default class VideoControl extends Vue {}
</script>

<style lang="stylus" scoped></style>
